<fs-dialog>
  <mat-dialog-content>
    <p>
      Choose the related help center you wish to access.
    </p>
    <div class="fs-row.justify-center.align-center.gap-lg mt-20 mb-20">
      <button
          mat-stroked-button
          (click)="openOrgSupport()"
          class="icon-button">
        <mat-icon
            color="primary"
            class="material-symbols-outlined-filled"
            [inline]="false">
          groups
        </mat-icon>
        <span>
          Organization
        </span>
      </button>
      <button
          mat-stroked-button
          (click)="openParentSupport()"
          class="icon-button">
        <mat-icon
            color="primary"
            [inline]="false">
          person
        </mat-icon>
        <span>
          Parent
        </span>
      </button>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button
        type="button"
        mat-button
        color="primary"
        mat-dialog-close>
      Cancel
    </button>
  </mat-dialog-actions>
</fs-dialog>